import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormaPago } from '../../../models/forma-pago';
import { Validation } from '../../../config/validation';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { CompraService } from '../../../services/compra.service';
import { Compra } from '../../../models/compra';
import { PagoService } from '../../../services/pago.service';
import { Pago } from '../../../models/pago';
import { PagoDetalle } from '../../../models/pago_detalle';
import { SessionService } from '../../../services/session.service';
import { SweetMessage } from '../../../config/sweet-message';
import * as numeral from 'numeral';
import { Retencion } from '../../../models/retencion';
import { Cheque } from '../../../models/cheque';
import { Tarjeta } from '../../../models/tarjeta';
import * as moment from 'moment';
import { ParametroService } from '../../../services/parametro.service';
import { DatosPagosComponent } from '../../../controls/datos-pago/datos-pago.component';
import { UtilsService } from '../../../services/utils.service';
import { Transferencia } from '../../../models/transferencia';
import { ParametroContabilidad } from '../../../models/parametro-contabilidad';
import { PeriodoContable } from '../../../models/periodo-contable';
import { PeriodoContableService } from '../../../services/periodo-contable.service';
import { ParametroContabilidadService } from '../../../services/parametro-contabilidad.service';
import { AsientoContable } from '../../../models/asiento-contable';
import { AsientoContableDetalle } from '../../../models/asiento-contable-detalle';
import { ConfirmacionAnulacionModalComponent } from '../../modals/confirmacion-anulacion-modal/confirmacion-anulacion-modal.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { ReporteModalComponent } from '../../modals/reporte-modal/reporte-modal.component';

@Component({
	selector: 'pago-add',
	templateUrl: './pago-add.component.html',
    styleUrls: ['./pago-add.component.css'],
    providers: [CompraService,PagoService,SessionService,ParametroService,ParametroContabilidadService,PeriodoContableService]
})
export class PagoAddComponent implements OnInit {
    public formasPago: Array<FormaPago>;
    public vl: Validation;
    public compra: Compra;
    public total_pago: number;
    public cambio: number;
    public pago: Pago;
    public msg: SweetMessage;
    public total_cobro: number;
    public loading = false;

    public cheques: Array<Cheque>;
    public tarjetas: Array<Tarjeta>;
    public transferencias: Array<Transferencia>;
    public valorefectivo: number;
    public fecha_pago;
    public numero_decimales: number;
    public format_decimal: String;
    public Mod_Cartera: string;
	public Mod_Contabilidad: string;
	public parametrosContabilidad: Array<ParametroContabilidad>;
    public periodoContable: PeriodoContable;
    bsModalRef: BsModalRef;
    public selectedRow: Number;
    @ViewChild(DatosPagosComponent) datosPagos: DatosPagosComponent;

	constructor(
        private activatedRoute: ActivatedRoute,
        public compraService: CompraService,
        public pagoService: PagoService,
        public ss: SessionService,
        public utils: UtilsService,
        public parametroService: ParametroService,
        private parametroContabilidadService: ParametroContabilidadService,
        private periodoContableService: PeriodoContableService,
        private modalService: BsModalService,
    ) {
        this.formasPago = [];
        this.vl = new Validation();
        this.compra  = new Compra();
        this.cambio = 0;
        this.total_pago = 0;
        this.pago = new Pago();
        this.msg = new SweetMessage();
        this.total_cobro = 0;
        this.cheques = [];
        this.tarjetas = [];
        this.transferencias = [];
        this.valorefectivo = 0;
        this.fecha_pago = moment(this.fecha_pago);
        this.numero_decimales = 2;
        this.format_decimal = "0,0.00";
        this.Mod_Cartera = this.ss.getData("mod_cartera");
		this.Mod_Contabilidad = this.ss.getData("mod_contabilidad");
		this.parametrosContabilidad = [];
		this.periodoContable = new PeriodoContable();
	}

	ngOnInit() {
        this.loading = true;
        let p1 = this.getParamNumeroDecimales();
        let p2 = this.getCompra();
        let p3 = null;
		if( this.Mod_Cartera && this.Mod_Contabilidad ) {
			p3 = this.getParametroContabilidadCompras();
		}
        Promise.all([p1,p2]).then(
            res => this.loading = false,
            err => this.loading = false
        );
    }

    getParametroContabilidadCompras(){
        return new Promise((resolve, reject) => {
			// let qs = "?in[id]=9,11,16,17,18,20,22&embed=cuentacontable";
			let qs = "?tipo=C&in[seccion]=IM,P&embed=cuentacontable";
			this.parametroContabilidadService.getAll(qs).subscribe(
				res => {
					let is_confirmedParametros = true;
					this.parametrosContabilidad.forEach(parametroContabilidad => {
						if( parametroContabilidad.cuenta_contable_id == null ){
							is_confirmedParametros = false;
							return false;
						}
					});
					if(!is_confirmedParametros){
						this.msg.showMessage('error-message', "Por favor, confirmar los parámetros de las cuentas contables.");
					}else{
						this.parametrosContabilidad = res.data;
					}
					resolve(true);
				},
				err => {
					reject(err);
				}
			);
            
        });
    }
    getPeriodoActual(){
        return new Promise((resolve, reject) => {
            let qs = "?periodo=" + moment().format('YYYY');
            this.periodoContableService.getPeriodoActual(qs).subscribe(
                res => {
                    this.periodoContable = res;
                    resolve(true);
                },
                err => {
                    reject(err);
                }
            );
        });
	}
    
    setValueAsientoContable(){
        
       
        let asientoContableCobros = new AsientoContable();
        asientoContableCobros.fecha_emision = this.pago.fecha_pago;
        asientoContableCobros.tipo_comprobante_id = null;
        asientoContableCobros.periodo_contable_id = this.periodoContable.id;
        asientoContableCobros.numero_documento = null;
        asientoContableCobros.descripcion = this.compra.proveedor.razon_social;
        asientoContableCobros.empresa_id = this.pago.empresa_id;
        asientoContableCobros.usuario_id = this.pago.usuario_id;
        asientoContableCobros.total = this.total_pago;
        asientoContableCobros.status = 'A';
		let valor_cheque= 0;
		let valor_tarjetas = 0;
		let valor_transferencias = 0;
		this.cheques.forEach(c=> {
			valor_cheque += Number(c.valor);
		});
		this.tarjetas.forEach(c=> {
			valor_tarjetas += Number(c.valor);
		});
		this.transferencias.forEach(c=> {
			valor_transferencias += Number(c.valor);
		});
        this.parametrosContabilidad.forEach(parametroContabilidad => {
            let asientoContableDetalle = new AsientoContableDetalle;
            asientoContableDetalle.empresa_id = asientoContableCobros.empresa_id;
			asientoContableDetalle.usuario_id = asientoContableCobros.usuario_id;
		
			if(parametroContabilidad.id == '27'){
                let total = this.compra.abonado == 0?Number(this.total_pago)*0.88:this.total_pago;
				asientoContableDetalle.haber = parametroContabilidad.tipo_saldo=='H'?this.utils.redondear(total, this.numero_decimales):0;
				asientoContableDetalle.debe = parametroContabilidad.tipo_saldo=='D'?this.utils.redondear(total, this.numero_decimales):0;
				asientoContableDetalle.cuenta_contable_id = parametroContabilidad.cuenta_contable_id;
                asientoContableDetalle.cuenta = parametroContabilidad.cuentacontable;
                if(parametroContabilidad.tipo_saldo == 'H'){
                    asientoContableCobros.detalle.push(asientoContableDetalle);   
                }else{
                    asientoContableCobros.detalle.unshift(asientoContableDetalle);   
                }
				
            }
            
            if(parametroContabilidad.id == '19' && this.compra.abonado == 0){
                let total = Number(this.total_pago)*0.12;
				asientoContableDetalle.haber = parametroContabilidad.tipo_saldo=='H'?this.utils.redondear(total, this.numero_decimales):0;
				asientoContableDetalle.debe = parametroContabilidad.tipo_saldo=='D'?this.utils.redondear(total, this.numero_decimales):0;
				asientoContableDetalle.cuenta_contable_id = parametroContabilidad.cuenta_contable_id;
                asientoContableDetalle.cuenta = parametroContabilidad.cuentacontable;
                if(parametroContabilidad.tipo_saldo == 'H'){
                    asientoContableCobros.detalle.push(asientoContableDetalle);   
                }else{
                    asientoContableCobros.detalle.unshift(asientoContableDetalle);   
                }
				// asientoContableCobros.detalle.push(asientoContableDetalle);   
			}
                asientoContableDetalle.cuenta_contable_id = parametroContabilidad.cuenta_contable_id;
                asientoContableDetalle.cuenta = parametroContabilidad.cuentacontable;
			if( parametroContabilidad.id == "23" && this.valorefectivo > valor_cheque && this.valorefectivo > valor_tarjetas && this.valorefectivo > valor_transferencias ) {
				asientoContableDetalle.haber = parametroContabilidad.tipo_saldo=='H'?this.utils.redondear(this.total_pago, this.numero_decimales):0;
			    asientoContableDetalle.debe = parametroContabilidad.tipo_saldo=='D'?this.utils.redondear(this.total_pago, this.numero_decimales):0;
                // asientoContableCobros.detalle.push(asientoContableDetalle);
                if(parametroContabilidad.tipo_saldo == 'H'){
                    asientoContableCobros.detalle.push(asientoContableDetalle);   
                }else{
                    asientoContableCobros.detalle.unshift(asientoContableDetalle);   
                }
			}
			else if( parametroContabilidad.id == "24" && valor_cheque > this.valorefectivo && valor_cheque > valor_tarjetas && valor_cheque > valor_transferencias ) {
				
				asientoContableDetalle.haber = parametroContabilidad.tipo_saldo=='H'?this.utils.redondear(this.total_pago, this.numero_decimales):0;
			    asientoContableDetalle.debe = parametroContabilidad.tipo_saldo=='D'?this.utils.redondear(this.total_pago, this.numero_decimales):0;
                // asientoContableCobros.detalle.push(asientoContableDetalle);
                if(parametroContabilidad.tipo_saldo == 'H'){
                    asientoContableCobros.detalle.push(asientoContableDetalle);   
                }else{
                    asientoContableCobros.detalle.unshift(asientoContableDetalle);   
                }
			}
			else if(  parametroContabilidad.id == "25" && valor_tarjetas > this.valorefectivo && valor_tarjetas > valor_cheque && valor_tarjetas > valor_transferencias ) {
				asientoContableDetalle.haber = parametroContabilidad.tipo_saldo=='H'?this.utils.redondear(this.total_pago, this.numero_decimales):0;
			    asientoContableDetalle.debe = parametroContabilidad.tipo_saldo=='D'?this.utils.redondear(this.total_pago, this.numero_decimales):0;
                // asientoContableCobros.detalle.push(asientoContableDetalle);
                if(parametroContabilidad.tipo_saldo == 'H'){
                    asientoContableCobros.detalle.push(asientoContableDetalle);   
                }else{
                    asientoContableCobros.detalle.unshift(asientoContableDetalle);   
                }
			}
			else if( parametroContabilidad.id == "26"  && valor_transferencias > this.valorefectivo && valor_transferencias > valor_tarjetas && valor_transferencias > valor_cheque ) {
				asientoContableDetalle.haber = parametroContabilidad.tipo_saldo=='H'?this.utils.redondear(this.total_pago, this.numero_decimales):0;
			    asientoContableDetalle.debe = parametroContabilidad.tipo_saldo=='D'?this.utils.redondear(this.total_pago, this.numero_decimales):0;
                // asientoContableCobros.detalle.push(asientoContableDetalle);
                if(parametroContabilidad.tipo_saldo == 'H'){
                    asientoContableCobros.detalle.push(asientoContableDetalle);   
                }else{
                    asientoContableCobros.detalle.unshift(asientoContableDetalle);   
                }
			}else if( parametroContabilidad.id == "23") {
                asientoContableDetalle.haber = parametroContabilidad.tipo_saldo=='H'?this.utils.redondear(this.total_pago, this.numero_decimales):0;
			    asientoContableDetalle.debe = parametroContabilidad.tipo_saldo=='D'?this.utils.redondear(this.total_pago, this.numero_decimales):0;
                // asientoContableCobros.detalle.push(asientoContableDetalle);
                if(parametroContabilidad.tipo_saldo == 'H'){
                    asientoContableCobros.detalle.push(asientoContableDetalle);   
                }else{
                    asientoContableCobros.detalle.unshift(asientoContableDetalle);   
                }
			}
				
		});
		this.pago.asientosContables.push(asientoContableCobros);
    }

    getCompra(){
        return new Promise((resolve, reject) => {
            
            this.activatedRoute.params.forEach((params: Params) => {
                let id = params['id'];
                let qs = '?embed=tipocomprobante,proveedor,pagos,grupo?embed=pago,retencion,amortizacion?embed=detalle';
               
                this.compraService.getById(id, qs).subscribe(
                    res => {
                        this.total_cobro = 0;
                        this.compra = res.data;

                        res.data.grupo.forEach(e => this.total_cobro += (e.pago.recibido - e.pago.cambio))
                        if( !this.compra.retencion ){
                            this.compra.retencion = new Retencion();
                        }

                        resolve();
                    },
                    err => {
                        reject(err);
                    }
                );
            });
        });
    }

    getParamNumeroDecimales(){
        return new Promise((resolve, reject) => {
            let numero_decimales = 19;
            this.parametroService.getById(numero_decimales).subscribe(
                res => {
                    this.numero_decimales = res.valor;

                    let digitos = "";
                    for(let i = 0; i < this.numero_decimales; i++) digitos += "0";

                    this.datosPagos.numero_decimales = this.numero_decimales;
                    this.datosPagos.setFormat();

                    this.format_decimal = "0,0." + digitos
                    resolve();
                },
                err => {
                    this.numero_decimales = 2;
                    this.format_decimal = "0,0.00"
                    reject(err);
                }
            );
        });
    }

    get formatDecimal(){
        return this.format_decimal;
    }

    numeroFactura(){
        return this.compra.serie + "-" + this.compra.punto_emision + "-" + this.compra.secuencial;
    }

    isFormValid(){
        if( this.fecha_pago.toString().trim().length  === 0 ){
            return false;
        }
        if( this.total_pago <= 0 ){
            return false;
        }
        return true;
    }

    openModalCuotas(template: TemplateRef<any>) {
        this.bsModalRef = this.modalService.show(template);
    }

    getEstadoCuota(estado){
        return (estado=="PE"?"PENDIENTE":"PAGADO");
    }

    setValueEntity(){
        this.pago.fecha_pago = moment(this.fecha_pago).format("YYYY-MM-DD");
        this.pago.saldo = this.compra.total - this.compra.abonado;
        // this.pago.saldo = this.compra.total-this.compra.retencion.total;
        this.pago.recibido = this.total_pago;
        this.pago.cambio = this.cambio;
        this.pago.compra_id = this.compra.id;
        this.pago.detalle = [];
        //this.pago.caja_id = this.ss.getData("caja_id");
        this.pago.empresa_id = this.ss.getData("empresa_id");
        this.pago.sucursal_id = this.ss.getData("sucursal_id");
        this.pago.usuario_id = this.ss.getData("usuario_id");

        if( this.valorefectivo > 0 ){
            let pago_detalle = new PagoDetalle();
            pago_detalle.valor = this.valorefectivo;
            
            pago_detalle.forma_pago_id = "1"; // EFECTIVO
            pago_detalle.empresa_id = this.ss.getData("empresa_id");
            pago_detalle.sucursal_id = this.ss.getData("sucursal_id");
            pago_detalle.usuario_id = this.ss.getData("usuario_id");
            this.pago.detalle.push(pago_detalle);
        }

        this.cheques.forEach(ch => {
            let pago_detalle = new PagoDetalle();

            pago_detalle.fecha_cheque = ch.fecha;
            pago_detalle.numero_cta = ch.cuenta;
            pago_detalle.numero_cheque = ch.numero;
            pago_detalle.banco_id = ch.banco_id;
            pago_detalle.observacion = ch.observacion;
            pago_detalle.valor = ch.valor;
            pago_detalle.forma_pago_id = ch.forma_pago_id; // CHEQUE
            pago_detalle.empresa_id = this.ss.getData("empresa_id");
            pago_detalle.sucursal_id = this.ss.getData("sucursal_id");
            pago_detalle.usuario_id = this.ss.getData("usuario_id");
            this.pago.detalle.push(pago_detalle);
        });

        this.tarjetas.forEach(tr => {
            let pago_detalle = new PagoDetalle();
            pago_detalle.debito_credito = tr.debito_credito;
            pago_detalle.observacion = tr.observacion;
            pago_detalle.tipo_tarjeta_id = tr.tipo_id;
            pago_detalle.valor = tr.valor;
            pago_detalle.plazo = tr.plazo;
            pago_detalle.tiempo = tr.tiempo;
            //pago_detalle.debito_credito = "C";
            pago_detalle.forma_pago_id = tr.forma_pago_id; // TARJETA
            pago_detalle.empresa_id = this.ss.getData("empresa_id");
            pago_detalle.sucursal_id = this.ss.getData("sucursal_id");
            pago_detalle.usuario_id = this.ss.getData("usuario_id");
            this.pago.detalle.push(pago_detalle);
        });

        this.transferencias.forEach(tr => {
			let pago_detalle = new PagoDetalle();

			pago_detalle.fecha_transferencia = tr.fecha;
			pago_detalle.numero_cta = tr.cuenta;
			pago_detalle.numero_comprobante = tr.numero;
			pago_detalle.banco_id = tr.banco_id;
			pago_detalle.observacion = tr.observacion;

			pago_detalle.valor = tr.valor;
			pago_detalle.forma_pago_id = tr.forma_pago_id; // TRANSFERENCIA
			pago_detalle.empresa_id = this.ss.getData("empresa_id");
			pago_detalle.sucursal_id = this.ss.getData("sucursal_id");
			pago_detalle.usuario_id = this.ss.getData("usuario_id");
			this.pago.detalle.push(pago_detalle);
		});
    }

    onSubmit(){
        this.setValueEntity();
        if( this.Mod_Cartera && this.Mod_Contabilidad ){

            this.getPeriodoActual().then(
                res => {
                    this.setValueAsientoContable();
                       this.savePago();   
                }
            );
        }else {
           this.savePago();   
        }
      
    }

    savePago(){
        this.loading = true;
        this.pagoService.save(this.pago).subscribe(
            res => {
                this.msg.showMessage('success-message', res.message);
                //this.venta = new Venta();
                this.pago = new Pago();
                this.cambio = 0;
                this.total_pago = 0;

                this.cheques = [];
                this.tarjetas = [];
                this.transferencias = [];
                this.valorefectivo = 0;

                this.datosPagos.total_cheque = 0;
                this.datosPagos.total_tarjeta = 0;
                this.datosPagos.total_efectivo = 0;
                this.datosPagos.total_transferencia = 0;

                let p1 = this.getCompra();

                Promise.all([p1]).then(
                    res => this.loading = false,
                    err => this.loading = false
                );
            },
            err => {
                this.loading = false;
                this.msg.showMessage('error-message',err);
            }
        );
    }

    anularPago(pago){
		let preg = "¿Está seguro de querer anular el registro?";
		const initialState = { Pregunta: preg, Respuesta:false };
		this.bsModalRef = this.modalService.show(ConfirmacionAnulacionModalComponent, Object.assign({}, {initialState}));

		this.bsModalRef.content.action.take(1).subscribe((Respuesta) => {
			if(Respuesta == true){
				// this.pago_anulado.observacion = this.observacion.toString().trim();
				// this.pago_anulado.usuario_id = this.ss.getData("usuario_id");
				// this.observacion  = "";
				
				this.loading = true;

				this.pagoService.anular(pago).subscribe(
					res => {
						this.bsModalRef.hide();
						// this.pago_anulado = new Pago();

						this.msg.showMessage('success-message', 'Se ha procesado correctamente');

						this.getCompra().then(
							res => {
								this.loading = false;
							},
							err => {
								this.loading = false;
							}
						);
					},
					err => {
						this.loading = false;
					}
				);
			}
			else{
				return;
			}
		});
    }
    
    imprimirComprobante(pago){
        let params = [];        
        params["empresa_id"] = this.ss.getData('empresa_id');
        params["usuario_id"] = this.ss.getData('usuario_id');
    
        if(pago.fecha_pago ){
          params["fecha_pago"]=pago.fecha_pago;
        }			
    
        if(this.compra.proveedor_id){
    
          params["proveedor_id"] = this.compra.proveedor_id;
        }
        
        if(pago.id){
          params["pago_id"] = pago.id;
        }
       
    
    
            let qs = [];
            for(let key in params){
                let str = key + "=" + params[key];
                qs.push(str);
            }
    
        const initialState = { route: "pago", qs: "?" + qs.join("&") + "&dbname=" + this.ss.getData('dbname') };
            this.bsModalRef = this.modalService.show(ReporteModalComponent, Object.assign({}, { class: 'modal-xlg', initialState }));
    }

    onChangeEfectivo(total){
        this.valorefectivo = total;
    }

    calcSaldo(compra){
        let saldo = compra.total - compra.abonado;

        if( compra.retencion ){
            saldo = saldo - compra.retencion.total;
        }

        //return saldo = Math.round(saldo * 100) / 100;
        return saldo = this.utils.redondear(saldo,this.numero_decimales);
    }

    calcularTotal(total){
        this.total_pago = total;

        //CALCULAR CAMBIO
        let saldo = this.compra.total - this.compra.abonado;

        if( this.compra.retencion ){
            saldo = saldo - this.compra.retencion.total;
        }

        this.cambio = (this.total_pago > saldo?(this.total_pago - saldo):0);
        //this.cambio = Math.round( this.cambio * 100) / 100;
        this.cambio = this.utils.redondear(this.cambio,this.numero_decimales);
    }

     onSelectRow(detalle, i) {
		//Asignacion de fila
		this.selectedRow = i;
		//Asignacion de producto
        this.valorefectivo = this.utils.redondear(detalle.saldo, this.numero_decimales);
        this.total_pago = this.valorefectivo;
	}

	onDBLClick(detalle,i)
	{
        this.onSelectRow(detalle,i);
        this.bsModalRef.hide();
		// this.onSubmit();
    }
    
    cancelarCuota(){
        this.valorefectivo = 0;
        this.bsModalRef.hide();
    }

    getDiasRestantes(detalle){
        let fecha_vencimiento = moment(detalle.fecha_vencimiento);
        return fecha_vencimiento.diff(moment(), 'days')
    }
}


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/compras/pago-add/pago-add.component.ts